var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("q-page", { attrs: { padding: "" } }, [
    _c(
      "div",
      { staticClass: "q-display-1 q-mb-md text-secondary" },
      [
        _c("q-icon", {
          staticClass: "q-mb-sm",
          attrs: { name: "far fa-list" }
        }),
        _vm._v(" " + _vm._s(_vm.$t("faq_categories")) + "\n    ")
      ],
      1
    ),
    _c("div", { staticClass: "row gutter-sm q-mb-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c(
            "q-field",
            { attrs: { count: 140 } },
            [
              _c("q-input", {
                attrs: {
                  "float-label": _vm.$t("title"),
                  error: _vm.$v.title.$error
                },
                on: { input: _vm.$v.title.$touch },
                model: {
                  value: _vm.title,
                  callback: function($$v) {
                    _vm.title = $$v
                  },
                  expression: "title"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-12" },
        [
          _c("p", { staticClass: "caption" }, [
            _vm._v(_vm._s(_vm.$t("status")))
          ]),
          _c("q-btn-toggle", {
            attrs: {
              "toggle-color": _vm.getColorStatus,
              options: _vm.statuses
            },
            model: {
              value: _vm.status,
              callback: function($$v) {
                _vm.status = $$v
              },
              expression: "status"
            }
          })
        ],
        1
      )
    ]),
    _c("div", { staticClass: "row gutter-sm justify-end q-mt-lg" }, [
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("cancel") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "tertiary",
              label: _vm.$t("back"),
              icon: "far fa-chevron-left"
            },
            on: {
              click: function($event) {
                return _vm.$router.push({ name: "admin_faq_categories" })
              }
            }
          })
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "col-xs-12 col-sm-3", class: _vm.getOrder("save") },
        [
          _c("q-btn", {
            staticClass: "full-width",
            attrs: {
              color: "secondary",
              label: _vm.$t("save"),
              icon: "far fa-save"
            },
            on: {
              click: function($event) {
                return _vm.saveData()
              }
            }
          })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }